(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drew-preorder-note')) {
    class DrewPreorderNote extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.container = this.closest('add-to-cart-component');
        if (!this.container) return;

        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-drew-preorder-message']
        });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.container = null;
      }

      sync() {
        const source = this.container?.querySelector(
          'button[ref="addToCartButton"] [data-drew-preorder-message]'
        );
        const message = source?.getAttribute('data-drew-preorder-message') || '';
        if (this.textContent !== message) this.textContent = message;
        const shouldHide = message.length === 0;
        if (this.hidden !== shouldHide) this.hidden = shouldHide;
      }
    }

    customElements.define('drew-preorder-note', DrewPreorderNote);
  }
  } catch(e) { console.error(e); }
})();

})();
